import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=37bc1f81&scoped=true&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"
import style0 from "./Button.vue?vue&type=style&index=0&id=37bc1f81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc1f81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37bc1f81')) {
      api.createRecord('37bc1f81', component.options)
    } else {
      api.reload('37bc1f81', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=37bc1f81&scoped=true&", function () {
      api.rerender('37bc1f81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/Button/Button.vue"
export default component.exports